import { actionsVPO, VPOInconsistences, VPOsettingsListName } from "src/pages/DashboardPage/vpo/api/vpo.config";
import { emailQueueListName } from "./email.config";
import {
  activityAnalysisListName,
  approversCardDocumentListName,
  approversDependenciesListName,
  approversListName,
  collectionsListName,
  contactsListName,
  copiesCardDocumentListName,
  departmentsListName,
  dependenciesListName,
  documentByCardFilesLibName,
  documentCodeIndexesListName,
  documentRegistryFilters,
  equipmentsByDocumentListName,
  equipmentsListName,
  favoriteDocumentsListName,
  favoriteFiltersListName,
  favoriteFoldersListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  instructionsFilesLibName,
  linesListName,
  LicensesInActionCardListName,
  ListFieldsKeys,
  listsApproversListName,
  myDocumentsListName,
  myTaskContactsListName,
  myTaskInstructionsFilesLibName,
  myTaskSettingsListName,
  myWorksDocumentsListName,
  NewsListName,
  paramsListName,
  processesListName,
  sectorsListName,
  settingsListName,
  siteUrl,
  statusesListName,
  systemsListName,
  templatesLibName,
  typesListName,
  usersByGroupListName,
  versionsByDocumentListName,
  versionsCardListName,
  ReplacedListName,
  MDWorkstationListName,
  usersListName,
  userRolesListName,
  MT5SInconsistencyListName,
  myDocumentsWithRelationsListName,
  myDocumentsOWDCalendarWithRelationsListName,
  myDocumentsEmployeeReportRelationsListName,
} from "./index";
import {
  myTaskCheckListsListName,
  myTaskCheckListResultsListName,
  myTaskCheckListDirectionsListName,
  myTaskCheckListConnectionWithTasksListName,
  myTaskCheckListCommentsFilesListName,
  myTaskCheckListCommentsListName,
  myTaskFrequenciesListName,
  myTaskCheckListTasksListName,
  myTaskMeetingsListName,
  myTaskCheckListsForUserListName,
  myTaskShiftListName,
} from "./meetings.config";
import {
  myTask5WayCommentsFilesListName,
  myTasks5WayCommentsListName,
  myTasks5WayEditorListName,
  myTasks5WayListName,
  myTasks5WayWithRelationsListName,
  myTasksSDCA5WayListName,
} from "./myTasks5Way.config";
import {
  myTaskActionCommentsListName,
  myTaskActionsHistoryListName,
  myTaskActionsListName,
  myTaskActionsStatusesListName,
  myTasksTagsListName,
  myTaskActionCommentsFilesListName,
} from "./myTasksActions.config";
import {
  myTasksAuditFilesListName,
  myTasksAuditListName,
  myTasksAuditQuestionsListName,
  myTasksAuditWithRelationsListName,
} from "./myTasksAudit.config";
import {
  myTaskIncCommentsFilesListName,
  myTaskIncCommentsListName,
  myTasksIncidentCardRecipientsListName,
  myTasksIncidentsQuestionsListName,
  myTasksIncidentsRecipientsListListName,
  myTasksIncidentsStatusesListName,
  myTasksIncidentstListName,
  myTasksIncidentstWithRelationsListName,
  myTasksTypeIncidentsListName,
} from "./myTasksInc.config";
import {
  MTFavoriteFiltersListName,
  MTTriggersPageListName,
  myTasks5WayDependListName,
  myTasks5WayStatusesListName,
  myTasksDepartmentsListName,
  myTasksDependListName,
  myTasksDeviationReportDependListName,
  myTasksDeviationReportKpiByTriggerListName,
  myTasksDeviationReportTriggersListName,
  myTasksKpiByTriggerListName,
  myTasksKPIListName,
  myTasksLocationsListName,
  myTasksRegionsListName,
  myTasksSDCAListName,
  myTasksTreeCategoriesListName,
  myTasksTriggersListName,
} from "./myTasksLists.config";
import {
  answersRegistry,
  checkListOWDIdsListName,
  checkListsOWDListName,
  getNotificationsListName,
  notificationIdsListName,
  notificationsCardListName,
  notificationsListName,
  notificationStatusesListName,
  notificationTestResult,
  notificationTests,
  notificationTestsAnswers,
  notificationTestsQuestion,
  questionsRegistry,
  sendNotificationsListName,
  templateOWDQuestionListName,
  templateOWDQuestionsListName,
  templatesOWDListName,
  testRegistry,
} from "./notifications.config";
import { aILogListName } from "./ai.config";

// Конфигурация для переключения между системами

export const isStrapi = true; // ключ для переключения между SharePoint и Strapi
export const siteUrlOrSiteApi = (isStrapi && siteUrl) || siteUrl; //strapiAPIUrl

// true = SharePoint, false = Strapi
export type SystemConfig = Record<ListFieldsKeys, string>;

// Полное покрытие всех списков с маппингом SharePoint -> Strapi
export const listMap = {
  // MyTasks списки
  [MT5SInconsistencyListName]: "mt-5-s-inconsistencies",
  [myTaskSettingsListName]: "mt-settings",
  [emailQueueListName]: "sp-queued-emails",
  [paramsListName]: "params-supplies",
  [myTasksLocationsListName]: "mt-locations",
  [myTasksDepartmentsListName]: "mt-departments",
  [myTasksRegionsListName]: "mt-areas",
  [myTaskFrequenciesListName]: "mt-frequencies",
  [myTasksDependListName]: "mt-depends",
  [myTasks5WayDependListName]: "mt-5-way-depends",
  [myTasksDeviationReportDependListName]: "mt-deviation-report-depends",
  [myTasksKpiByTriggerListName]: "mt-kpi-by-triggers",
  [myTasksDeviationReportKpiByTriggerListName]: "mt-deviation-report-kpi-by-triggers",
  [myTasksTriggersListName]: "mt-triggers",
  [myTasksDeviationReportTriggersListName]: "mt-deviation-report-triggers",
  [myTasksKPIListName]: "mt-kpis",
  [myTasks5WayStatusesListName]: "mt-5-way-statuses",
  [myTasksSDCAListName]: "mt-sdcas",
  [myTasksTreeCategoriesListName]: "mt-tree-categories",
  [MTFavoriteFiltersListName]: "mt-favorite-filters",
  [MTTriggersPageListName]: "mt-depends/triggers-page",

  // MyTaskActions списки
  [myTaskActionCommentsFilesListName]: "mt-action-comments-files:folder",
  [myTaskActionCommentsListName]: "mt-action-comments",
  [myTaskActionsListName]: "mt-actions",
  [myTaskActionsHistoryListName]: "mt-actions-histories",
  [myTaskActionsStatusesListName]: "mt-actions-statuses",
  [myTasksTagsListName]: "mt-tags",

  // MyTaskMeetings списки
  [myTaskMeetingsListName]: "mt-meetings",
  [myTaskCheckListsForUserListName]: "mt-check-lists-for-users",

  // MyTaskCheckLists списки
  [myTaskCheckListsListName]: "mt-check-lists",
  [myTaskCheckListTasksListName]: "mt-check-list-tasks",
  [myTaskCheckListResultsListName]: "my-task-check-list-results",
  [myTaskCheckListDirectionsListName]: "mt-check-list-directions",
  [myTaskCheckListConnectionWithTasksListName]: "mt-check-list-connection-with-tasks",
  [myTaskCheckListCommentsListName]: "mt-check-list-tasks-comments",
  [myTaskCheckListCommentsFilesListName]: "mt-check-list-tasks-comments-files:folder",
  [myTaskShiftListName]: "mt-shifts",

  // MyTaskContacts списки
  [myTaskContactsListName]: "mt-contacts",
  [myTaskInstructionsFilesLibName]: "mt-instructions:folder",

  //MyTaskAudit списки
  [myTasksAuditListName]: "mt-audits",
  [myTasksAuditWithRelationsListName]: "mt-audits/list-with-relations",
  [myTasksAuditQuestionsListName]: "mt-audit-questions",
  [myTasksAuditFilesListName]: "mt-audit-files:folder",

  //MyTask5Why списки
  [myTasks5WayListName]: "mt-5-ways",
  [myTasks5WayWithRelationsListName]: "mt-5-ways/list-with-relations",
  [myTasksSDCA5WayListName]: "mt-sdca5-ways",
  [myTasks5WayCommentsListName]: "mt-5-way-comments",
  [myTask5WayCommentsFilesListName]: "mt-5-way-comments-files:folder",
  [myTasks5WayEditorListName]: "mt-5-way-editors",

  //MyTaskInc списки
  [myTasksIncidentstListName]: "mt-incidents",
  [myTasksIncidentstWithRelationsListName]: "mt-incidents/list-with-relations",
  [myTasksIncidentsQuestionsListName]: "mt-inc-questions",
  [myTasksTypeIncidentsListName]: "mt-type-incs",
  [myTaskIncCommentsListName]: "mt-inc-comments",
  [myTaskIncCommentsFilesListName]: "mt-inc-comments-files:folder",
  [myTasksIncidentsStatusesListName]: "mt-inc-statuses",
  [myTasksIncidentsRecipientsListListName]: "mt-inc-report-recipients",
  [myTasksIncidentCardRecipientsListName]: "mt-inc-recipients",

  //MD списки
  [activityAnalysisListName]: "analytics",
  [equipmentsListName]: "equipments",
  [listsApproversListName]: "lists-approvers:folder",
  [answersRegistry]: "md-answers-registries",
  [approversListName]: "md-approvers",
  [approversDependenciesListName]: "md-approvers-dependencies",
  [approversCardDocumentListName]: "md-approvers-documents",
  [checkListOWDIdsListName]: "md-check-list-owd-ids",
  [checkListsOWDListName]: "md-check-lists-owds",
  [documentCodeIndexesListName]: "md-code-indexes",
  [collectionsListName]: "md-collections",
  [contactsListName]: "md-contacts",
  [copiesCardDocumentListName]: "md-copies",
  [departmentsListName]: "md-departments",
  [dependenciesListName]: "md-dependencies",
  [myWorksDocumentsListName]: "md-documents",
  [myDocumentsListName]: "md-documents",
  [myDocumentsWithRelationsListName]: "md-documents/list-with-relations",
  [myDocumentsOWDCalendarWithRelationsListName]: "md-documents/list-with-relations-owd-calendar",
  [myDocumentsEmployeeReportRelationsListName]: "md-documents/list-with-relations-employee-report",
  [documentByCardFilesLibName]: "md-documents-file:folder",
  [equipmentsByDocumentListName]: "md-equip-by-documents",
  [favoriteDocumentsListName]: "md-favorite-documents",
  [favoriteFiltersListName]: "md-favorite-filters",
  [favoriteFoldersListName]: "md-favorite-folders",
  [historyByDocumentListName]: "md-histories",
  [historyChangeFieldsDocumentListName]: "md-history-change-fields",
  [instructionsFilesLibName]: "md-instructions:folder",
  [linesListName]: "md-lines",
  [notificationsListName]: "md-notifications",
  [notificationIdsListName]: "md-notification-ids",
  [getNotificationsListName]: "md-notifications",
  [sendNotificationsListName]: "md-notifications",
  [notificationsCardListName]: "md-notifications",
  [notificationStatusesListName]: "md-notification-statuses",
  [notificationTests]: "md-notification-tests",
  [notificationTestResult]: "md-notification-test-results",
  [notificationTestsAnswers]: "md-notification-tests-answers",
  [notificationTestsQuestion]: "md-notification-tests-questions",
  [processesListName]: "md-processes",
  [questionsRegistry]: "md-questions-registries",
  [documentRegistryFilters]: "md-report-filters",
  [sectorsListName]: "md-sectors",
  [settingsListName]: "md-settings",
  [statusesListName]: "md-statuses",
  [templatesLibName]: "md-templates",
  [templateOWDQuestionsListName]: "md-template-owd-multy-questions",
  [templateOWDQuestionListName]: "md-template-owd-questions",
  [templatesOWDListName]: "md-templates-owds",
  [testRegistry]: "md-test-registries",
  [typesListName]: "md-types",
  [versionsByDocumentListName]: "md-versions",
  [versionsCardListName]: "md-versions",
  [usersByGroupListName]: "users-search-by-groups",
  [ReplacedListName]: "md-replacings",
  [MDWorkstationListName]: "md-workstations",

  //VPO списки
  [actionsVPO]: "vpo-actions",
  [VPOInconsistences]: "vpo-inconsistencies",
  [VPOsettingsListName]: "vpo-settings",

  //GOS списки
  // [ViolationsGosInActionCardListName]: "gos-violations", Включить когда перенесут гос на страпи
  [LicensesInActionCardListName]: "gos-licensees",

  // Остальные списки - по умолчанию оставляем как есть
  // Если нужно переименовать для Strapi, раскомментируй и измени
  [systemsListName]: systemsListName,
  [NewsListName]: "news-supplies:folder",
  [usersListName]: "custom-users",
  [userRolesListName]: "user-roles",
  // Добавь остальные списки здесь...

  //AI списки
  [aILogListName]: "ai-logs",
} as SystemConfig;

// Конфигурация маппинга полей Strapi -> SharePoint
// Ключ: имя списка, Значение: объект маппинга { новое_поле: старое_поле }
export const FIELD_MAPPING_CONFIG: Record<string, Record<string, string>> = {
  [systemsListName]: {
    UID: "ID",
  },
  // Пример для MyTaskActions
  [myTaskActionsListName]: {
    CardStatus: "Status", // новое поле newStatus -> старое поле CardStatus
    id: "ID",
  },
  [MTFavoriteFiltersListName]: {
    id: "ID",
  },
  [NewsListName]: {
    id: "ID",
  },
  [myTaskActionsHistoryListName]: {
    CardStatus: "Status",
  },
  [myTasksSDCA5WayListName]: {
    FiveWhy: "_x0035_Way",
    id: "ID",
  },
  [myTasks5WayCommentsListName]: {
    FiveWhy: "_x0035_Way",
  },
  [myTasks5WayWithRelationsListName]: {
    Type5Why: "Type5Way",
    Date5Why: "Date5Way",
    Area: "Region",
    CardStatus: "Status",
    Kpi: "KPI",
  },
  [myTasks5WayListName]: {
    Type5Why: "Type5Way",
    Date5Why: "Date5Way",
    Area: "Region",
    CardStatus: "Status",
    Kpi: "KPI",
  },
  [myTasksAuditListName]: {
    Area: "Region",
  },
  [myTasksAuditWithRelationsListName]: {
    Area: "Region",
  },
  [myTasksIncidentstListName]: {
    Area: "Region",
    CardStatus: "Status",
  },
  [myTasksIncidentstWithRelationsListName]: {
    Area: "Region",
    CardStatus: "Status",
  },
  [myTasks5WayDependListName]: {
    Area: "Region",
    Department: "Departament",
  },
  [myTasksDependListName]: {
    Area: "Region",
    Department: "Departament",
  },
  [myTasksDeviationReportDependListName]: {
    Area: "Region",
    Department: "Departament",
  },
  [myTasks5WayEditorListName]: {
    FiveWhy: "_x0035_Way",
  },
  [myTasksAuditQuestionsListName]: {
    Key: "dc0t",
  },
  [myTasks5WayStatusesListName]: {
    Text5Why: "Text5Way",
  },
  // Добавьте другие списки по необходимости
  [myTaskMeetingsListName]: {
    Statuses: "Status", // SharePoint Status -> Strapi Statuses
    id: "ID",
  },
  [myTaskCheckListTasksListName]: {
    id: "ID",
  },
  [myTaskCheckListsListName]: {
    id: "ID",
  },
  [myTaskActionsStatusesListName]: {
    id: "ID",
    IsStatus: "Status",
  },
  [myDocumentsListName]: {
    id: "ID",
    CardStatus: "Status",
    Column: "Sector",
    ColumnBlockArea: "Process",
  },
  [myDocumentsWithRelationsListName]: {
    id: "ID",
    CardStatus: "Status",
    Column: "Sector",
    ColumnBlockArea: "Process",
  },
  [myDocumentsOWDCalendarWithRelationsListName]: {
    id: "ID",
    CardStatus: "Status",
    Column: "Sector",
    ColumnBlockArea: "Process",
  },
  [myDocumentsEmployeeReportRelationsListName]: {
    id: "ID",
    CardStatus: "Status",
    Column: "Sector",
    ColumnBlockArea: "Process",
  },
  [versionsByDocumentListName]: {
    id: "ID",
    CardStatus: "Status",
    Column: "Sector",
    ColumnBlockArea: "Process",
  },
  [copiesCardDocumentListName]: {
    IDDocument: "DocumentID",
  },
  [historyByDocumentListName]: {
    IDDocument: "DocumentID",
  },
  [historyChangeFieldsDocumentListName]: {
    IDDocument: "DocumentID",
  },
  [dependenciesListName]: {
    Column: "Sector",
    ColumnBlockArea: "Process",
  },
  [approversDependenciesListName]: {
    Collection: "Collection",
    Order: "Order0",
    Users: "Users",
    DefaultApprovers: "DefaultApprovers",
  },
  [listsApproversListName]: {
    IdDocument: "DocumentID",
  },
};

// Функция для получения маппинга полей
export const getFieldMapping = (listName: string, isStrapiFlag: boolean = false): Record<string, string> | null => {
  const mapping = FIELD_MAPPING_CONFIG[listName];

  if (!mapping) {
    return null;
  }

  if (isStrapiFlag) {
    // Для Strapi -> SharePoint: ищем по значению и возвращаем ключ
    const reverseMapping: Record<string, string> = {};
    Object.entries(mapping).forEach(([key, value]) => {
      reverseMapping[value] = key;
    });
    return reverseMapping;
  }

  // Для SharePoint -> Strapi: возвращаем как есть
  return mapping;
};

export const getListByStrapi = (listName: ListFieldsKeys): string | null => {
  return listMap[listName] || null;
};

export const actionsStatus = {
  process: (isStrapi && 228) || 2,
  edited: (isStrapi && 233) || 7,
  copy: (isStrapi && 237) || 13,
  created: (isStrapi && 232) || 6,
  addComment: (isStrapi && 235) || 9,
  closed: (isStrapi && 231) || 5,
  editedComment: (isStrapi && 236) || 10,
  notStart: (isStrapi && 227) || 1,
  cancel: (isStrapi && 230) || 4,
  old: (isStrapi && 229) || 3,
  deleteComment: (isStrapi && 234) || 8,
};

export const fiveWhyStatus = {
  process: (isStrapi && 16) || 1,
  closed: (isStrapi && 17) || 2,
  escalate: (isStrapi && 18) || 3,
  old: (isStrapi && 19) || 4,
  cancel: (isStrapi && 20) || 5,
};

export const incStatus = {
  process: (isStrapi && 16) || 1,
  finish: (isStrapi && 17) || 2,
  old: (isStrapi && 18) || 3,
  cancel: (isStrapi && 19) || 4,
  closed: (isStrapi && 20) || 5,
};

export const incTypes = {
  security: (isStrapi && 20) || 5,
  safe: (isStrapi && 16) || 1,
  q: (isStrapi && 18) || 3,
  m: (isStrapi && 19) || 4,
  e: (isStrapi && 17) || 2,
};

export const nTrigger = {
  safe: (isStrapi && 734) || 792,
  q: (isStrapi && 736) || 794,
  e: (isStrapi && 735) || 793,
  m: (isStrapi && 737) || 795,
};

export const incTrigger = {
  safe: (isStrapi && 374) || 77,
  q: (isStrapi && 376) || 79,
  e: (isStrapi && 375) || 78,
  m: (isStrapi && 378) || 81,
  process: (isStrapi && 377) || 80,
};

export const FiveWhyType = (isStrapi && "FiveWay") || "5Way";

export const docApprovers = {
  Creater: 6,
  ShiftSupervisor: 1,
  SafetyEcology: 2,
  Quality: 3,
  Manager: 4,
  TechManager: 5,
  TestGroup_1: 7,
  TestGroup_2: 8,
  ZB: 9,
  BOPs: 10,
};

export const docStatuses = {
  draft: 1,
  revision: 2,
  review: 3,
  cancel: 4,
  approval: 5,
  archive: 6,
  approved: 7,
  public: 8,
  created: 9,
  sendApproval: 10,
  waitApproval: 11,
  edited: 12,
  agreed: 13,
  sendRevision: 14,
  actual: 15,
  notActual: 16,
  notPublic: 17,
  saveDraft: 18,
  reWork: 19,
  notArchive: 20,
  sendArchive: 21,
};

export const notificationStatuses = {
  acquainted: 1,
  getOWD: 2,
  approval: 3,
  acquaintedTest: 4,
  familiarization: 5,
  OWD: 6,
  cancel: 7,
  approved: 8,
  revision: 9,
  cancelNotification: 10,
};
